import React from "react";

const WhatsappPage = () => {
  return (
    <div
      style={{
        padding: "24px",
        background: "#fff",
        minHeight: "100%",
        borderRadius: "8px",
      }}
    >
      <h1>Whatsapp Page</h1>
    </div>
  );
};

export default WhatsappPage;
